import { getPrice } from '@fourthwall/utils'

import type { SubscriptionPlan } from '../Subscriptions.types'

type ValueType = 'price' | 'creditForSamples'

type Params = {
  subscriptionPlan?: SubscriptionPlan
  valueType: ValueType
  separatorType?: 'short' | 'full'
  withPeriod?: boolean
  options?: Parameters<typeof getPrice>[1]
}

export const getSubscriptionPeriodValue = (params: Params) => {
  const { subscriptionPlan, valueType, separatorType = 'full', withPeriod = true, options } = params

  if (!subscriptionPlan) return ''

  const value = subscriptionPlan[valueType]
  const price = getPrice(value.value, {
    currency: value.currency,
    ...options,
  })

  if (value.value === 0) return price

  const periodLabel =
    subscriptionPlan.recurringPeriod && subscriptionPlan.recurringPeriod === 'YEARLY'
      ? 'year'
      : 'month'
  const separator = separatorType === 'full' ? ' per ' : '/'

  return `${price}${
    value.value && value.value > 0 && withPeriod ? `${separator}${periodLabel}` : ''
  }`
}

export const getSubscriptionPrice = (
  params: Omit<Params, 'valueType'> = { separatorType: 'full', withPeriod: true },
) => {
  return getSubscriptionPeriodValue({
    ...params,
    valueType: 'price',
  })
}

export const getSubscriptionSamplesCreditGrant = (
  params: Omit<Params, 'valueType'> = { separatorType: 'full', withPeriod: true },
) => {
  return getSubscriptionPeriodValue({
    ...params,
    valueType: 'creditForSamples',
  })
}
